import { Skeleton } from '@mint-lib/tw-components';

const BudgetStructureSkeleton = () => (
  <div className="flex flex-col gap-2">
    <div className="flex flex-col gap-2 rounded-lg bg-ui-primary p-6 shadow">
      <div className="flex items-center justify-between">
        <Skeleton className="h-6 w-1/3" />
        <Skeleton className="h-5 w-16 rounded-md" />
      </div>
      <div>
        <div className="mt-2 mb-1 flex">
          <Skeleton className="h-4 w-32" />
        </div>
        <Skeleton className="h-6 w-full rounded-md" />
      </div>
      <div>
        <div className="mt-2 mb-1 flex">
          <Skeleton className="h-4 w-20" />
        </div>
        <div className="flex flex-col gap-1">
          <Skeleton className="h-6 rounded-md" />
          <Skeleton className="ml-8 h-6 rounded-md" />
        </div>
      </div>
    </div>
  </div>
);

export default BudgetStructureSkeleton;
